import { render, staticRenderFns } from "./c_wechat_attention.vue?vue&type=template&id=17bb85f1&scoped=true&"
import script from "./c_wechat_attention.vue?vue&type=script&lang=js&"
export * from "./c_wechat_attention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bb85f1",
  null
  
)

export default component.exports